import React from 'react';
import { useTranslation } from 'react-i18next';
import { utils, writeFile } from 'xlsx';

const DownloadExcelWithHeaders = ({
  data,
  fileName,
  sheetName,
  onDownload,
  BtnName,
  customHeaders,
  columnWidths = [],
//   headerStyle = {
//     font: { bold: true },
//     fill: { fgColor: { rgb: 'FFFF00' } },//Header styling
//     alignment: { horizontal: 'center' },
//   }
headerStyle
}) => {
  const { t } = useTranslation();

  const downloadExcel = () => {
    const workbook = utils.book_new();

    //  custome headers: directly use customHeaders if provided
    const headers = customHeaders ? [customHeaders] : [Object.keys(data[0]).reduce((acc, curr) => ({...acc, [curr]: curr}), {})];
    const dataWithHeaders = [...headers, ...data];

    const worksheet = utils.json_to_sheet(dataWithHeaders, { skipHeader: true });

    // Adjust column widths if provided
    if (columnWidths.length > 0) {
      worksheet['!cols'] = columnWidths;
    }

    // custom header styles
    const headerKeys = Object.keys(headers[0]);
    headerKeys.forEach((key, index) => {
      const cellRef = utils.encode_cell({ r: 0, c: index });
      worksheet[cellRef].s = headerStyle;
    });

    utils.book_append_sheet(workbook, worksheet, sheetName);
    if (typeof onDownload === 'function') {
      onDownload(); // Callback function indicating download is starting
    }
    writeFile(workbook, fileName);
  };

  return (
    <button className="" style={{ border: 'none', background: 'none', fontFamily: 'Lato' }} onClick={downloadExcel}>
      <span>{BtnName ? BtnName : t('btnGrpText.download')}</span>
    </button>
  );
};

export default DownloadExcelWithHeaders;
